import { Button, Divider, Row, Space, Typography } from 'antd';
import { FC } from 'react';

import { env } from 'src/app/env';

import { showConfirmModal } from '../utils/modalHelpers';

const { Text, Link } = Typography;

interface ProgramStepFooterProps {
  programId: number | undefined;
  removeNextButton?: boolean;
  nextButtonText?: string;
  style?: React.CSSProperties;
  isDisabledCancelButton?: boolean;
  isNextButtonDisabled?: boolean;
  isLoadingNextButton?: boolean;
  isDanger?: boolean;
  onCancelConfirmation?: () => void;
}

export const ProgramStepFooter: FC<ProgramStepFooterProps> = ({
  programId,
  removeNextButton,
  style = {},
  nextButtonText,
  isNextButtonDisabled,
  isDisabledCancelButton,
  isLoadingNextButton,
  isDanger = false,
  onCancelConfirmation,
}) => {
  const link = `${env.URL_SITE}/program/${programId}`;

  const handleCancel = () => {
    showConfirmModal({
      title: 'Deseja realmente cancelar?',
      content:
        'Com isso você perderá todos os dados não salvos, deseja realmente descartar as alterações?',
      cancelText: 'Não, continuar editando',
      onOk: onCancelConfirmation,
    });
  };

  return (
    <div
      style={{
        ...style,
        zIndex: 99,
        backgroundColor: '#141414',
        padding: '0 32px 32px 80px',
      }}
    >
      <Divider style={{ marginTop: 0 }} />

      <Row>
        {!!programId && (
          <div>
            <Text strong>Visualize o programa:</Text>
            <br />
            <Link href={link} target='_blank'>
              {link}
            </Link>
          </div>
        )}

        <Space style={{ marginLeft: 'auto' }}>
          <Button
            style={{
              borderRadius: '6px',
              paddingLeft: '16px',
              paddingRight: '16px',
            }}
            onClick={handleCancel}
            disabled={isDisabledCancelButton}
          >
            Cancelar
          </Button>
          {!removeNextButton && (
            <Button
              type='primary'
              htmlType='submit'
              danger={isDanger}
              style={{
                borderRadius: '6px',
                paddingLeft: '16px',
                paddingRight: '16px',
              }}
              disabled={isNextButtonDisabled}
              loading={isLoadingNextButton}
            >
              {nextButtonText}
            </Button>
          )}
        </Space>
      </Row>
    </div>
  );
};
